export default __webpack_public_path__ + "static/media/sticker-s.58885d39.png";